<template>
  <div class="manage-panel-exposure-record-container manage-panel-inner-container">
    <div class="control">
      <el-input
        v-model="listQuery.name"
        size="small"
      >
        <template #suffix>
          <svg-icon :iconName="listQuery.loading?'loading':'el-Search'"
            @click="queryExposureListFn"
          ></svg-icon>
        </template>
      </el-input>
    </div>
    <el-scrollbar
      class="inner-scrollbar"
    >
      <div class="item-entity"
        v-for="(item, index) of dataList"
        :key="index"
        @click="entityClick(item)"
        :class="{
          'item-entity-hover': item == clickCheckItem,
        }"
      >
        <div class="title ellipsis"
          :title="item['name']"
        >
          {{ item['name'] }}
        </div>
        <div class="title ellipsis">
          {{ item['startTime'] }} ~ {{ item['endTime'] }}
        </div>
      </div>
    </el-scrollbar>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.length"
        layouts="total, pager,"
      />
    </div>
    <teleport to="#home-body">
      <EditPopup
        class="manage-panel-exposure-record-Charts"
        v-if="chartsList.length > 0"
        title="线索区数据"
        :controls="chartsControls"
      >
        <FrequencyChart
          :showFlag="true"
          :dataList="chartsList"
          ref="frequencyChartRef"
        ></FrequencyChart>
      </EditPopup>
    </teleport>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import Pagination from '@/components/Pagination';
import FrequencyChart from '../WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/Frequency/components/FrequencyChart';
import EditPopup from '../WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/EditPopup';

import { queryExposureList, } from '@/api/ExposureApi';

const xlsx = require('xlsx');

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);
const homeMap = computed(() => store.getters.getHomeMap),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      }

const frequencyChartRef = ref();
const chartDownloadFn = ()=>{
  frequencyChartRef.value && frequencyChartRef.value['chartDownloadFn'] && frequencyChartRef.value['chartDownloadFn']();
}


const downloadList = [
  { name: '日期', prop: 'exposureTime' },
  { name: '次数', prop: 'count' },
],
excelHeader = downloadList.map(e=>{
  return e.name;
})
const downloadExposureFn = ()=>{
  // console.log(xlsx);
  if(!clickCheckItem.value){
    message('请选择线索数据', 2);
    return;
  }
  const data = [
    excelHeader,
    ...(
      chartsList.value.map(item=>{
        return downloadList.map(e=>{
          return item[e.prop];
        })
      })
    )
  ];
  const ws = xlsx.utils.aoa_to_sheet(data);
  const wb = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
  xlsx.writeFile(wb, `${ clickCheckItem.value['name'] }.xlsx`);
}

const chartsControls = [
  { iconName: 'download-center', fill: 'rgb(102, 203, 118)', title: '数据导出', onClick: downloadExposureFn, },
  { iconName: 'image', fill: 'rgb(102, 203, 118)', title: '图片导出', onClick: chartDownloadFn, },
  { iconName: 'close-box', fill: 'rgb(6, 180, 221)', onClick: ()=>{ chartsList.value = [] }, },
]

const dataList = ref([]), chartsList = ref([]);

const total = ref(0),
    listQuery = reactive({
      page: 1,
      length: 20,
      name: '',
      loading: false,
    })
// 分页器change
const pageChange = ()=>{
  queryExposureListFn()
}

const clickCheckItem = ref(undefined), clickCheckItemChange = (item)=>{
  clickCheckItem.value = item;
};

const entityClick = async (target)=>{
  layerGroupClear();
  if(clickCheckItem.value == target){
    clickCheckItemChange(undefined);
  }else{
    clickCheckItemChange(target);
    layerInit(target['dataList']);
    chartsList.value = target['dateExposureList'];
  }
}

const layerInit = (data)=>{
  data.forEach((item, index)=>{
    const text = `
      ${ item['scanSatelliteType'] } ${ item['scanProductCloudPercent'] }<br/>
      ${ item['scanProductTime'] }
    `;
    L.geoJSON(
      JSON.parse(item['scanSatellitePolygon'])
    ).bindTooltip(text, {
      // offset: [0, 40],
      sticky: true,
      className: "leaflet-tooltip-message",
      direction: 'top',
      // maxWidth: 300,
      // maxHeight: 20,
      // permanent: true,
    }).addTo(layerGroup);
  })
  const bounds = layerGroup.getBounds();
  bounds.isValid() && map.fitBounds(bounds, {
    maxZoom: 9,
  });
}

const queryExposureListFn = (list)=>{
  layerGroupClear();
  listQuery.loading = true;
  queryExposureList({
    ...listQuery,
    pager: {
      ...listQuery,
    }
  }).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.dataList;
      total.value = res.data.totalCount;
    }
  }).catch(err=>{
    console.log(err);
  }).finally(()=>{
    listQuery.loading = false;
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  queryExposureListFn();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
});

defineExpose({
  downloadExposureFn,
})

</script>

<style lang='less'>
.manage-panel-exposure-record-Charts{
  position: absolute;
  bottom: 10px;
  left: 10px;
  .custom-locale-control-edit-popup-body{
    width: 800px;
    height: 320px !important;
  }
}
</style>

<style lang='less' scoped>
.manage-panel-exposure-record-container{
  .control{
    :deep(.el-input){
      .el-input__suffix{
        i{
          cursor: pointer;
          width: 14px;
          height: 14px;
        }
      }
    }
  }
  // .inner-scrollbar{
  //   .item-entity{
  //     display: flex;
  //     .title{
  //       flex: 1;
  //       min-width: 0;
  //     }
  //   }
  // }
}
</style>